"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Store = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _require = require('postmsg-rpc'),
    caller = _require.caller;

var _require2 = require('abstract-leveldown'),
    AbstractLevelDOWN = _require2.AbstractLevelDOWN;

var _require3 = require('./utils'),
    serialize = _require3.serialize,
    deserialize = _require3.deserialize;

var Store = /*#__PURE__*/function (_AbstractLevelDOWN) {
  (0, _inherits2["default"])(Store, _AbstractLevelDOWN);

  function Store(location, options) {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2["default"])(this, Store);

    for (var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
      args[_key - 2] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2["default"])(this, (_getPrototypeOf2 = (0, _getPrototypeOf3["default"])(Store)).call.apply(_getPrototypeOf2, [this, location, options].concat(args)));
    _this.location = location;
    _this.opts = Object.assign({}, options);
    delete options.postMessage;
    caller('create', _this.opts).apply(void 0, [_this.location, options].concat(args));
    return _this;
  }

  (0, _createClass2["default"])(Store, [{
    key: "_serializeKey",
    value: function _serializeKey(key) {
      return serialize(key);
    }
  }, {
    key: "_serializeValue",
    value: function _serializeValue(value) {
      return serialize(value);
    }
  }, {
    key: "_deserialize",
    value: function _deserialize(v) {
      return deserialize(v);
    }
  }, {
    key: "_open",
    value: function () {
      var _open2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(options, callback) {
        var open;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                open = caller('open', this.opts);
                _context.prev = 1;
                _context.next = 4;
                return open(this.location, options);

              case 4:
                _context.next = 9;
                break;

              case 6:
                _context.prev = 6;
                _context.t0 = _context["catch"](1);
                callback(_context.t0);

              case 9:
                callback();

              case 10:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[1, 6]]);
      }));

      function _open(_x, _x2) {
        return _open2.apply(this, arguments);
      }

      return _open;
    }()
  }, {
    key: "_close",
    value: function () {
      var _close2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(callback) {
        var close;
        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                close = caller('close', this.opts);
                _context2.prev = 1;
                _context2.next = 4;
                return close(this.location);

              case 4:
                _context2.next = 9;
                break;

              case 6:
                _context2.prev = 6;
                _context2.t0 = _context2["catch"](1);
                callback(_context2.t0);

              case 9:
                callback();

              case 10:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[1, 6]]);
      }));

      function _close(_x3) {
        return _close2.apply(this, arguments);
      }

      return _close;
    }()
  }, {
    key: "_get",
    value: function () {
      var _get2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3(key, options, callback) {
        var get, response;
        return _regenerator["default"].wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                get = caller('get', this.opts);
                _context3.prev = 1;
                _context3.next = 4;
                return get(this.location, key, options);

              case 4:
                response = _context3.sent;
                _context3.next = 11;
                break;

              case 7:
                _context3.prev = 7;
                _context3.t0 = _context3["catch"](1);
                _context3.t0.notFound = true;
                return _context3.abrupt("return", callback(_context3.t0));

              case 11:
                callback(null, this._deserialize(response));

              case 12:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[1, 7]]);
      }));

      function _get(_x4, _x5, _x6) {
        return _get2.apply(this, arguments);
      }

      return _get;
    }()
  }, {
    key: "_put",
    value: function () {
      var _put2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee4(key, value, options, callback) {
        var put, response;
        return _regenerator["default"].wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                put = caller('put', this.opts);
                _context4.prev = 1;
                _context4.next = 4;
                return put(this.location, key, value, options);

              case 4:
                response = _context4.sent;
                _context4.next = 10;
                break;

              case 7:
                _context4.prev = 7;
                _context4.t0 = _context4["catch"](1);
                callback(_context4.t0);

              case 10:
                callback(null, response);

              case 11:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this, [[1, 7]]);
      }));

      function _put(_x7, _x8, _x9, _x10) {
        return _put2.apply(this, arguments);
      }

      return _put;
    }()
  }, {
    key: "_del",
    value: function () {
      var _del2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee5(key, options, callback) {
        var del, response;
        return _regenerator["default"].wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                del = caller('del', this.opts);
                _context5.prev = 1;
                _context5.next = 4;
                return del(this.location, key, options);

              case 4:
                response = _context5.sent;
                _context5.next = 10;
                break;

              case 7:
                _context5.prev = 7;
                _context5.t0 = _context5["catch"](1);
                callback(_context5.t0);

              case 10:
                callback(null, response);

              case 11:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this, [[1, 7]]);
      }));

      function _del(_x11, _x12, _x13) {
        return _del2.apply(this, arguments);
      }

      return _del;
    }()
  }, {
    key: "_batch",
    value: function () {
      var _batch2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee6(arr, options, callback) {
        var batch, response;
        return _regenerator["default"].wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                batch = caller('batch', this.opts);
                _context6.prev = 1;
                _context6.next = 4;
                return batch(this.location, arr, options);

              case 4:
                response = _context6.sent;
                _context6.next = 10;
                break;

              case 7:
                _context6.prev = 7;
                _context6.t0 = _context6["catch"](1);
                callback(_context6.t0);

              case 10:
                callback(null, response);

              case 11:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this, [[1, 7]]);
      }));

      function _batch(_x14, _x15, _x16) {
        return _batch2.apply(this, arguments);
      }

      return _batch;
    }()
  }]);
  return Store;
}(AbstractLevelDOWN);

exports.Store = Store;